import React from "react";
import { withRedux, dig } from "helpers";
import { Logo, Profile, JoyRide } from "components";
import * as styles from "./nav.styles";
import styled, { css } from "react-emotion";
import { isMobileDevice } from "helpers";

const spanStyle = css`
  display: none;
  @media only screen and (min-width: 900px) {
    font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
      Verdana, sans-serif;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #89d2d3;
    display: inline-block;
    margin-right: 10px;
  }
`;

class Nav extends React.Component {
  render() {
    const firstName = dig(
      this.props,
      "platformInfo",
      "status",
      "user",
      "firstName"
    );
    const lastName = dig(
      this.props,
      "platformInfo",
      "status",
      "user",
      "lastName"
    );
    const appName = dig(this.props, "activeApp", "name");
    const isLobby = this.props.location.pathname === "/lobby";
    const isMob = isMobileDevice();
    const history = this.props.history;

    return (
      <div className={styles.navContainer}>
        <Logo history={history} />
        {!isLobby && !isMob && <h1 className={styles.appTitle}>{appName}</h1>}
        <div className={styles.rightSide}>
          <JoyRide />
          {firstName && lastName ? (
            <span className={spanStyle}>Welcome back, {firstName}!</span>
          ) : (
            <span className={spanStyle}></span>
          )}

          <Profile />
        </div>
      </div>
    );
  }
}

export default withRedux(Nav);
